module.exports = __webpack_public_path__ + "static/img/11.0eb6615.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/11.png
// module id = jNtB
// module chunks = 0